import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=0d1c450c&scoped=true&"
import script from "./ItemMenu.vue?vue&type=script&lang=js&"
export * from "./ItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./ItemMenu.vue?vue&type=style&index=0&id=0d1c450c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c450c",
  null
  
)

export default component.exports